import services from './../services/service'; // Service Class
import validate from './../services/validation'; // Validator Class
import activity from './activity'; //Activity class
import setts from './setts'; //settings class

//push-notification
import { Capacitor } from '@capacitor/core';
import {PushNotifications} from '@capacitor/push-notifications';
//../push-notification

let service = new services();
let validator = new validate();

export default {
    name: 'Settings',
    mixins: [activity,setts],
    data () {
      return {
        app_name: service.app_name,
        //states
        users:{},
        user:{},
        states:{},
        cities:{},
        //variables
        discount_coupon:{},
        discount_coupon_is_gift_card: false,
        discount_coupon_is_direct: false,
        discount_coupon_is_private:false,
        //actions
        action_procs:{},
        action_verified:{},
        action_checking:{},
        //messages
        error_messages:{},
        //
        data_validated:false,
        formComponentKey:0,
      }
  },

    methods: {
        //data calls
        getStates() {
            service.getStates(this).then(function(data) {
                this.states = data.body;
            })
        },

        getCities(state) {
            service.getCities(this, state).then(function(data) {
                this.cities = data.body;
            })
        },
        //..data calls

        //validate calls
        validateEmail(data_attr_value){
            if((data_attr_value != '') && (data_attr_value != undefined)){
                this.error_messages.email = "";
                if(validator.validateEmail(data_attr_value)){
                    this.validateData("user","email",data_attr_value);
                }else{
                    this.error_messages.email = "Email is not valid";
                }
                // console.log(this.error_messages.email)
                this.formComponentKey++;
            }
        },

        validatePhone(data_attr_value){
            if((data_attr_value != '') && (data_attr_value != undefined)){
                this.error_messages.phone = "";
                if(validator.validatePhoneNumber(data_attr_value)){
                    this.validateData("user","phone",data_attr_value);
                }else{
                    this.error_messages.phone = "Phone Number is not valid";
                    this.user.phone = ""; //redo
                }
                this.formComponentKey++;
            }
        },

        validateUsername(data_attr_value){
            if((data_attr_value != '') && (data_attr_value != undefined)){
                this.error_messages.username = "";
                if(validator.validateString(data_attr_value)){
                    this.validateData("user","username",data_attr_value);
                }else{
                    this.error_messages.username = "Username is not valid"; 
                }
                this.form2ComponentKey++;
            }
        },

        validateData(data_type,data_attr,data_attr_value){
            this.disable_btn = true;
            this.action_checking[data_attr] = true;
            var credentials = {
                data_type: data_type,
                data_attr: data_attr,
                data_attr_value: data_attr_value,
            }
            service.validateDataExist(this, credentials).then(function(data) {
                if(data.body.status == 200) {
                    this.action_checking[data_attr] = false;
                    this.action_verified[data_attr] = true;
                    this.data_validated = true;
                }else{
                    this.action_checking[data_attr] = '';
                    this.action_verified[data_attr] = false;
                    this.error_messages[data_attr] = data.body.message;
                }
                this.disable_btn = false;
                this.formComponentKey++;
            })
            this.formComponentKey++;
        },

        validateDataXXX(data_type,data_attr){
            this.disable_btn = true;
            let data_attr_value = '';
            if(data_attr == 'email'){
                data_attr_value = this.user.email;
                this.action_checking.email = true;
            }else if(data_attr == 'phone'){
                data_attr_value = this.user.phone;
            }else if(data_attr == 'username'){
                data_attr_value = this.user.username;
            }
            this.action_checking[data_attr] = true;
            var credentials = {
                data_type: data_type,
                data_attr: data_attr,
                data_attr_value: data_attr_value,
            }
            service.validateDataExist(this, credentials).then(function(data) {
                if(data.body.status == 200) {
                    this.action_checking[data_attr] = false;
                    this.action_verified[data_attr] = true;
                    this.data_validated = true;
                }else{
                    this.action_checking[data_attr] = false;
                    this.error_messages[data_attr] = data.body.message;
                }
                this.formComponentKey++;
                this.disable_btn = false;
            })
            this.formComponentKey++;
        },
        //.../validate calls

        //set calls
        //--set coupons and discount
        setDiscountsAndCoupons(){
            this.activate_processing();
            this.data_processing_message = "";
            //settings for product and producitems
            if(this.product_details.setProductDiscount || this.product_details.setProductItemDiscount){
                this.discount_coupon.discount_category = 1;  //HACK..TO LET GO ../ASSIGNED 1 instead of 0.
            }
            
            //validate entry
            let entry_arr = [
                ["Discount or Coupon",this.discount_coupon.is_discount_coupon,"str"],
                ["Coupon Percentage",this.discount_coupon.discount_percentage,"num"],
                ["Discount Category",this.discount_coupon.discount_category,"num"],
                ["Start Date",this.discount_coupon.discount_start_date,"date"],
                ["End Date",this.discount_coupon.discount_end_date,"date"]
            ];
            let validated_arr = validator.validate_array(entry_arr,"Please fill in ");
            if(validated_arr.length == 0){
                //check if end date is greater than start date
                var start_date = new Date(this.discount_coupon.discount_start_date);
                var end_date = new Date(this.discount_coupon.discount_end_date)
                if(end_date <= start_date){
                    this.data_processing_message = "Please reset Dates, End Date should be greater than Start Date";
                    this.deactivate_processing();
                }else{
                    //set for business category
                    let discount_category  = 0;
                    if(this.business_details.setDiscount){
                        discount_category = this.discount_coupon.discount_category;
                    }

                    //set for product and product items
                    let product_id = 0;
                    let product_item_id = 0;
                    
                    if(this.product_details.setProductDiscount || this.product_details.setProductItemDiscount){
                        product_id = this.product.product_id;
                    }
                    if(this.product_details.setProductItemDiscount){
                        product_item_id = this.product_item.product_item_id;
                    }
                    //set for product and product items

                    //coupon style eg gift cards
                    let coupon_style_type = 0;
                    if(this.discount_coupon_is_gift_card){
                        coupon_style_type = 36; //default set value
                    }
                    //coupon specific uses
                    let coupon_is_specific_use = 0;
                    if(this.discount_coupon_is_direct){
                        coupon_is_specific_use = 1; //default set value
                    }
                    //coupon is private //..for manul code entry set
                    let coupon_is_private = 0;
                    if(this.discount_coupon_is_private){
                        coupon_is_private = 1; //default set value
                    }
                    //
                    var payload = {
                        business_id: this.sellpoint.business_id,
                        business_market: service.apiToken,
                        product_id: product_id,
                        product_item_id: product_item_id,
                        is_coupon_or_discount: this.discount_coupon.is_discount_coupon || 'C', //or coupon
                        coupon_business_category:discount_category,
                        coupon_style_type: coupon_style_type,
                        coupon_is_private: coupon_is_private,
                        coupon_is_specific_use: coupon_is_specific_use,
                        coupon_for_account: this.discount_coupon.discount_username,
                        coupon_description: this.discount_coupon.discount_description || "NIL",
                        coupon_percentage: this.discount_coupon.discount_percentage,
                        coupon_min_amount: this.discount_coupon.discount_min_amount || 0,
                        coupon_min_quantity: this.discount_coupon.discount_min_quantity,
                        coupon_start_date: this.discount_coupon.discount_start_date,
                        coupon_end_date: this.discount_coupon.discount_end_date,
                    }
                    service.setDiscountsAndCoupons(this, payload).then(function(data) {
                        if(data.body.status == 201) {
                            // toastr.success("New Discount Set", 'Update!');
                            // this.sellpoint.business_discounts_coupons = data.body.data;
                            this.business_details.setDiscount = false;
                            this.business_details.viewDiscounts = true;
                            this.discount_coupon_is_gift_card = false;
                            if(this.product_details.setProductDiscount || this.product_details.setProductItemDiscount){
                                let res = data.body.data;
                                for(let item of this.product.product_items){
                                    for(let row of res){
                                        if(row.product_item_id == item.product_item_id){
                                            item.product_item_discounts = row.product_item_discounts;
                                        }
                                    }
                                    // item.product_item_discounts = res.filter(function(discount){ return discount.discount_product_item == item.product_item_id;});
                                }
                                if(this.product_details.setProductDiscount){
                                    this.product.product_only_coupon_discount_count++;
                                }
                                if(this.product_details.setProductItemDiscount){
                                    this.product_item.product_item_only_coupon_discount_count++;
                                }
                            }else{
                                //this.sellpoint.business_discounts_coupons = data.body.data; 
                                this.sellpoint.business_discounts_coupons = data.body.data_business; 
                                //commit
                                this.$store.dispatch('account/setBusinessDiscounts',this.sellpoint.business_discounts_coupons);
                            }
                            this.deactivate_processing();
                            this.product_details = {};
                        }
                    }).catch((err) => {
                        //log it
                        this.deactivate_processing();
                    })
                }//date reset check
            }else{
                validated_arr.forEach(function(error) {
                    // toastr.error(error); 
                    this.data_processing_message =  this.data_processing_message + " . " +error;
                }, this);
                this.deactivate_processing();
            }
            
        },
        //../set calls


       
        //PUSH-NOTIFICATIONS
        
        routeNotification(notification){
            console.log('solidd==889',JSON.stringify(notification));
            console.log(JSON.stringify(notification.data))
            let redir = notification.data.action;
            if((redir != undefined) && (redir != '')){
                this.$router.push(redir);
            }else{
                this.$router.push('/register');
            }
           
        },

        sendAppToken(token){
            let self = this;
            localforage.getItem(service.udb_name, function(err, value) { //quick with the callback version
                if(value != undefined) {
                    self.user.user_id = value.user_id;
                }
                console.log('u7888')
                //
                var payload = {
                    token: token,
                    user: self.user.user_id || 0,
                    app: service.market_app_name,
                    app_temp_co_share: service.market_app_temp_co_share,
                }
                if(payload.token != undefined && payload.app_token != '') {
                    service.sendAppToken(self, payload).then(function(data) {
                        console.log(payload.user)
                        if(data.body.status == 201) {
                            console.log("App Token Sent To Server")
                        }else{
                            console.log("App Token NOT Sent To Server")
                        }
                    }).catch((err) => {
                        console.log("App Token Server ERROR: "+JSON.stringify(err))
                    })
                }
            });
            // if(checkrun){
                
            // }
        },

        setPushNotification(){
            const isPushNotificationsAvailable = Capacitor.isPluginAvailable('PushNotifications');
     
            if (isPushNotificationsAvailable) {
            
                //promises hub
                let promises = [];
                for (let i = 0; i < 7; ++i) {
                    if(i == 1){
                        console.log('wwkkk-0999')
                        PushNotifications.register();
                        PushNotifications.addListener('registration', token => {
                            console.info('Registration token: ', token.value);
                            //send notification to remote receiver
                            this.sendAppToken(token.value);
                        });
                    } 
                    if(i == 2){
                        PushNotifications.addListener('registrationError', err => {
                            console.error('Registration error: ', err.error);
                        });
                    } 
                    if(i == 3){ 
                        PushNotifications.addListener('pushNotificationReceived', notification => {
                            console.log('Push notification received: ', notification);
                            console.log('kkkk-1010Push notification received', JSON.stringify(notification));
                            console.dir(notification);
                        });
                    } 
                    if(i == 4){  
                        PushNotifications.addListener('pushNotificationActionPerformed', notification => {
                            console.log('Push notification action performed', notification.actionId, notification.inputValue);
                            //check if can go
                            console.log('kkkk-1010Push notification performed', JSON.stringify(notification.notification));
                            this.routeNotification(notification.notification);
                        });
                    } 
                    if(i == 5){
                        let permStatus = PushNotifications.checkPermissions();
                      
                          if (permStatus.receive === 'prompt') {
                            permStatus = PushNotifications.requestPermissions();
                          }
                      
                          if (permStatus.receive !== 'granted') {
                            throw new Error('User denied permissions!');
                          }
                        } 
                    if(i == 6){
                        console.log('77-kkk-0999')
                        //PushNotifications.register();
                    } 
                }
                //process all promises
                // Promise.all(promises)
                // .then(() => { 
                //     console.log('877gggg')
                // })
                // .catch((e) => {
                //     // handle errors here
                // });
                //..promises hub

            }
        },
        //.../PUSH-NOTIFICATIONS
        
    },
    created: function(){}
}


// WEBPACK FOOTER //
// ./src/resources/commons.js